import { Component } from '@angular/core';


@Component({
    selector: "page",
    templateUrl: './page.component.html',
    inputs: ["title", "icon", "menu", "submenu", "blockedUI", "msgs", "dialogTitle"],
    styles: [".centered {         position:  absolute ; z-index:10000000000;        top: 50%;        left: 50%;      }"]
})
export class PageComponent {



}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/custom-component/PageComponent.ts